// src/components/surveys/questions/YesNoQuestion.tsx
import React from 'react';
import { SurveyQuestion } from '../../../types/survey.types';

interface YesNoQuestionProps {
  question: SurveyQuestion;
  value?: 'yes' | 'no' | null;
  onChange?: (value: 'yes' | 'no') => void;
  disabled?: boolean;
  showValidation?: boolean;
  error?: string;
  mode?: 'edit' | 'preview' | 'response';
}

const YesNoQuestion: React.FC<YesNoQuestionProps> = ({
  question,
  value,
  onChange,
  disabled = false,
  showValidation = false,
  error,
  mode = 'response',
}) => {
  const handleSelect = (answer: 'yes' | 'no') => {
    if (!disabled && onChange) {
      onChange(answer);
    }
  };

  if (mode === 'edit') {
    return (
      <div className="space-y-3">
        <div className="text-sm text-gray-500">Preview:</div>
        <div className="flex gap-4">
          <button
            type="button"
            className="flex-1 py-3 px-4 border-2 border-green-300 bg-green-50 rounded-lg text-green-700 font-medium"
            disabled
          >
            Yes
          </button>
          <button
            type="button"
            className="flex-1 py-3 px-4 border-2 border-red-300 bg-red-50 rounded-lg text-red-700 font-medium"
            disabled
          >
            No
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex gap-4">
        <button
          type="button"
          onClick={() => handleSelect('yes')}
          disabled={disabled}
          className={`flex-1 py-3 px-4 border-2 rounded-lg font-medium transition-all ${
            value === 'yes'
              ? 'border-green-500 bg-green-100 text-green-700'
              : 'border-gray-200 bg-white text-gray-600 hover:border-green-300 hover:bg-green-50'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => handleSelect('no')}
          disabled={disabled}
          className={`flex-1 py-3 px-4 border-2 rounded-lg font-medium transition-all ${
            value === 'no'
              ? 'border-red-500 bg-red-100 text-red-700'
              : 'border-gray-200 bg-white text-gray-600 hover:border-red-300 hover:bg-red-50'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          No
        </button>
      </div>
      {showValidation && error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default YesNoQuestion;
